import { useState } from 'react';
import { ReactComponent as Cancel } from '../assets/cancel.svg';

export default function Premium ({setShowPremium, title = false}) {
    const [currentPlan, setCurrentPlan] = useState('free');

    const openTallyForm = () => {
        // Replace with your Tally form URL
        window.open('https://tally.so/your-form-url', '_blank');
    };

    return (
        <div className="overlay">
            <div className="premium">
                <div className="close" onClick={() => setShowPremium(false)}>
                    <Cancel />
                </div>

                {title && <h1>{title}</h1>}

                <div className="title">
                    Upgrade Your Lagoon Experience
                </div>

                <div className="subscriptions">
                    <div className={`subscription ${currentPlan === 'free' ? 'current-plan' : ''}`}>
                        <div className="subtitle">Free Plan</div>
                        <div className="includes">Free Plan Includes:</div>
                        <ul>
                            <li>1 project</li>
                            <li>Limited activities</li>
                            <li>Standard QR codes</li>
                            <li>Basic analytics</li>
                        </ul>
                        <div className="prices">
                            <div className="price">$0/month</div>
                        </div>
                        <div className='plan-subtitle'>Perfect for individuals and small teams</div>
                        <div className="button button_blue">Current Plan</div>
                    </div>

                    <div className={`subscription ${currentPlan === 'enterprise' ? 'current-plan' : ''}`}>
                        <div className="subtitle">Enterprise Plan</div>
                        <div className="includes">Enterprise Plan Includes:</div>
                        <ul>
                            <li>Unlimited projects</li>
                            <li>All premium activity components</li>
                            <li>Custom QR code design</li>
                            <li>Detailed QR scan analytics</li>
                            <li>Priority support</li>
                        </ul>
                        <div className="prices">
                            <div className="price">Custom Pricing</div>
                        </div>
                        <div className='plan-subtitle'>Tailored for growing businesses and large organizations</div>
                        <div className="button button_blue" onClick={openTallyForm}>Schedule a Call</div>
                    </div>
                </div>

                <div className="footer-text">
                    Upgrade to Enterprise and unlock the full potential of Lagoon for your business.
                </div>
            </div>
        </div>
    )
}
